<div class="dropListWrapper" cdkDropList [cdkDropListData]="items" [cdkDropListSortingDisabled]="true">
    <div class="columns-{{gridColumnCount}}" *ngFor="let row of getRowsArray()">
        <div class="card-img-parent" *ngFor="let card of getCards(row)" cdkDrag [cdkDragData]="card">
            <app-card-image [card]="card" [isValid]="isValid" (click)="onCardClicked(card)" (cardContextClicked)="cardContextClicked.emit($event)"></app-card-image>
        </div>
    </div>
</div>
